import type { AxiosResponse } from "axios";

import { ClientGateway } from "@kex/api";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { requisitesApi } from "@shared/api";

import { constants } from "./constants";

interface UseRequisitesDetailsParams {
  id: string;
  initialData?: AxiosResponse<ClientGateway.BankAccountModel>;
}

export const requisitesDetailsQueryOptions = ({
  id,
  initialData,
}: UseRequisitesDetailsParams) =>
  queryOptions({
    initialData,
    queryFn: () => requisitesApi.getApiV1BankAccountsId({ id }),
    queryKey: constants.detail(id),
  });

export const useRequisitesDetails = (params: UseRequisitesDetailsParams) => {
  const { data, error, isPending } = useSuspenseQuery(
    requisitesDetailsQueryOptions(params),
  );

  return {
    error,
    requisitesDetails: data.data,
    isPending,
  };
};
